window.theme = window.theme || {};
window.Shopify = window.Shopify || {};

theme.config = {
    bpSmall: false,
    hasSessionStorage: true,
    hasLocalStorage: true,
    mediaQuerySmall: "screen and (max-width: " + 769 + "px)",
    youTubeReady: false,
    vimeoReady: false,
    vimeoLoading: false,
    isTouch: "ontouchstart" in window || (window.DocumentTouch && window.document instanceof DocumentTouch) || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false,
    stickyHeader: false,
    rtl: document.documentElement.getAttribute("dir") == "rtl" ? true : false,
};

if (theme.config.isTouch) {
    document.documentElement.className += " supports-touch";
}

theme.recentlyViewed = {
    recent: {},
    productInfo: {},
};

theme.delegate = {
    on: function (event, callback, options) {
        if (!this.namespaces)
            // save the namespaces on the DOM element itself
            this.namespaces = {};

        this.namespaces[event] = callback;
        options = options || false;

        this.addEventListener(event.split(".")[0], callback, options);
        return this;
    },
    off: function (event) {
        if (!this.namespaces) {
            return;
        }
        this.removeEventListener(event.split(".")[0], this.namespaces[event]);
        delete this.namespaces[event];
        return this;
    },
};

window.on = Element.prototype.on = theme.delegate.on;
window.off = Element.prototype.off = theme.delegate.off;

theme.utils = {
    defaultTo: function (value, defaultValue) {
        return value == null || value !== value ? defaultValue : value;
    },

    wrap: function (el, wrapper) {
        el.parentNode.insertBefore(wrapper, el);
        wrapper.appendChild(el);
    },

    debounce: function (wait, callback, immediate) {
        var timeout;
        return function () {
            var context = this,
                args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) callback.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) callback.apply(context, args);
        };
    },

    throttle: function (limit, callback) {
        var waiting = false;
        return function () {
            if (!waiting) {
                callback.apply(this, arguments);
                waiting = true;
                setTimeout(function () {
                    waiting = false;
                }, limit);
            }
        };
    },

    prepareTransition: function (el, callback) {
        el.addEventListener("transitionend", removeClass);

        function removeClass(evt) {
            el.classList.remove("is-transitioning");
            el.removeEventListener("transitionend", removeClass);
        }

        el.classList.add("is-transitioning");
        el.offsetWidth; // check offsetWidth to force the style rendering

        if (typeof callback === "function") {
            callback();
        }
    },

    // _.compact from lodash
    // Creates an array with all falsey values removed. The values `false`, `null`,
    // `0`, `""`, `undefined`, and `NaN` are falsey.
    // _.compact([0, 1, false, 2, '', 3]);
    // => [1, 2, 3]
    compact: function (array) {
        var index = -1,
            length = array == null ? 0 : array.length,
            resIndex = 0,
            result = [];

        while (++index < length) {
            var value = array[index];
            if (value) {
                result[resIndex++] = value;
            }
        }
        return result;
    },

    serialize: function (form) {
        var arr = [];
        Array.prototype.slice.call(form.elements).forEach(function (field) {
            if (!field.name || field.disabled || ["file", "reset", "submit", "button"].indexOf(field.type) > -1) return;
            if (field.type === "select-multiple") {
                Array.prototype.slice.call(field.options).forEach(function (option) {
                    if (!option.selected) return;
                    arr.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(option.value));
                });
                return;
            }
            if (["checkbox", "radio"].indexOf(field.type) > -1 && !field.checked) return;
            arr.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value));
        });
        return arr.join("&");
    },
};

theme.initWhenVisible = function (options) {
    // Init section function when it's visible, then disable observer
    var threshold = options.threshold ? options.threshold : 0;

    var observer = new IntersectionObserver(
        (entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    if (typeof options.callback === "function") {
                        options.callback();
                        observer.unobserve(entry.target);
                    }
                }
            });
        },
        { rootMargin: "0px 0px " + threshold + "px 0px" }
    );

    observer.observe(options.element);
};

theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];

    document.addEventListener("shopify:section:load", this._onSectionLoad.bind(this));
    document.addEventListener("shopify:section:unload", this._onSectionUnload.bind(this));
    document.addEventListener("shopify:section:select", this._onSelect.bind(this));
    document.addEventListener("shopify:section:deselect", this._onDeselect.bind(this));
    document.addEventListener("shopify:block:select", this._onBlockSelect.bind(this));
    document.addEventListener("shopify:block:deselect", this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
    _createInstance: function (container, constructor, scope) {
        var id = container.getAttribute("data-section-id");
        var type = container.getAttribute("data-section-type");

        constructor = constructor || this.constructors[type];

        if (typeof constructor === "undefined") {
            return;
        }

        // If custom scope passed, check to see if instance
        // is already initialized so we don't double up
        if (scope) {
            var instanceExists = this._findInstance(id);
            if (instanceExists) {
                this._removeInstance(id);
            }
        }

        // If a section fails to init, handle the error without letting all subsequest section registers to fail
        try {
            var instance = Object.assign(new constructor(container), {
                id: id,
                type: type,
                container: container,
            });
            this.instances.push(instance);
        } catch (e) {
            console.error(e);
        }
    },

    _findInstance: function (id) {
        for (var i = 0; i < this.instances.length; i++) {
            if (this.instances[i].id === id) {
                return this.instances[i];
            }
        }
    },

    _removeInstance: function (id) {
        var i = this.instances.length;
        var instance;

        while (i--) {
            if (this.instances[i].id === id) {
                instance = this.instances[i];
                this.instances.splice(i, 1);
                break;
            }
        }

        return instance;
    },

    _onSectionLoad: function (evt, subSection, subSectionId) {
        if (window.AOS) {
            AOS.refreshHard();
        }
        if (theme && theme.initGlobals) {
            theme.initGlobals();
        }

        var container = subSection ? subSection : evt.target;
        var section = subSection ? subSection : evt.target.querySelector("[data-section-id]");

        if (!section) {
            return;
        }

        this._createInstance(section);

        var instance = subSection ? subSectionId : this._findInstance(evt.detail.sectionId);

        // Check if we have subsections to load
        var haveSubSections = container.querySelectorAll("[data-subsection]");
        if (haveSubSections.length) {
            this.loadSubSections(container);
        }

        // Run JS only in case of the section being selected in the editor
        // before merchant clicks "Add"
        if (instance && typeof instance.onLoad === "function") {
            instance.onLoad(evt);
        }

        // Force editor to trigger scroll event when loading a section
        setTimeout(function () {
            window.dispatchEvent(new Event("scroll"));
        }, 200);
    },

    _onSectionUnload: function (evt) {
        this.instances = this.instances.filter(function (instance) {
            var isEventInstance = instance.id === evt.detail.sectionId;

            if (isEventInstance) {
                if (typeof instance.onUnload === "function") {
                    instance.onUnload(evt);
                }
            }

            return !isEventInstance;
        });
    },

    loadSubSections: function (scope) {
        if (!scope) {
            return;
        }

        var sections = scope.querySelectorAll("[data-section-id]");

        sections.forEach((el) => {
            this._onSectionLoad(null, el, el.dataset.sectionId);
        });
    },

    _onSelect: function (evt) {
        var instance = this._findInstance(evt.detail.sectionId);

        if (typeof instance !== "undefined" && typeof instance.onSelect === "function") {
            instance.onSelect(evt);
        }
    },

    _onDeselect: function (evt) {
        var instance = this._findInstance(evt.detail.sectionId);

        if (typeof instance !== "undefined" && typeof instance.onDeselect === "function") {
            instance.onDeselect(evt);
        }
    },

    _onBlockSelect: function (evt) {
        var instance = this._findInstance(evt.detail.sectionId);

        if (typeof instance !== "undefined" && typeof instance.onBlockSelect === "function") {
            instance.onBlockSelect(evt);
        }
    },

    _onBlockDeselect: function (evt) {
        var instance = this._findInstance(evt.detail.sectionId);

        if (typeof instance !== "undefined" && typeof instance.onBlockDeselect === "function") {
            instance.onBlockDeselect(evt);
        }
    },

    register: function (type, constructor, scope) {
        this.constructors[type] = constructor;

        var sections = document.querySelectorAll('[data-section-type="' + type + '"]');

        if (scope) {
            sections = scope.querySelectorAll('[data-section-type="' + type + '"]');
        }

        sections.forEach(
            function (container) {
                this._createInstance(container, constructor, scope);
            }.bind(this)
        );
    },

    reinit: function (section) {
        for (var i = 0; i < this.instances.length; i++) {
            var instance = this.instances[i];
            if (instance["type"] === section) {
                if (typeof instance.forceReload === "function") {
                    instance.forceReload();
                }
            }
        }
    },
});

theme.Testimonials = (function () {
    var defaults = {
        adaptiveHeight: true,
        avoidReflow: true,
        pageDots: true,
        prevNextButtons: false,
    };

    function Testimonials(container) {
        this.container = container;
        this.timeout;
        var sectionId = container.getAttribute("data-section-id");
        this.slideshow = container.querySelector("#Testimonials-" + sectionId);
        this.namespace = ".testimonial-" + sectionId;

        if (!this.slideshow) {
            return;
        }

        theme.initWhenVisible({
            element: this.container,
            callback: this.init.bind(this),
            threshold: 600,
        });
    }

    Testimonials.prototype = Object.assign({}, Testimonials.prototype, {
        init: function () {
            // Do not wrap when only a few blocks
            if (this.slideshow.dataset.count <= 3) {
                defaults.wrapAround = false;
            }

            this.flickity = new theme.Slideshow(this.slideshow, defaults);

            // Autoscroll to next slide on load to indicate more blocks
            if (this.slideshow.dataset.count > 2) {
                this.timeout = setTimeout(
                    function () {
                        this.flickity.goToSlide(1);
                    }.bind(this),
                    1000
                );
            }
        },

        onUnload: function () {
            if (this.flickity && typeof this.flickity.destroy === "function") {
                this.flickity.destroy();
            }
        },

        onDeselect: function () {
            if (this.flickity && typeof this.flickity.play === "function") {
                this.flickity.play();
            }
        },

        onBlockSelect: function (evt) {
            var slide = this.slideshow.querySelector(".testimonials-slide--" + evt.detail.blockId);
            var index = parseInt(slide.dataset.index);

            clearTimeout(this.timeout);

            if (this.flickity && typeof this.flickity.pause === "function") {
                this.flickity.goToSlide(index);
                this.flickity.pause();
            }
        },

        onBlockDeselect: function () {
            if (this.flickity && typeof this.flickity.play === "function") {
                this.flickity.play();
            }
        },
    });

    return Testimonials;
})();

class Slideshow {
    static classes = {
        animateOut: "animate-out",
        isPaused: "is-paused",
        isActive: "is-active",
    };

    static selectors = {
        allSlides: ".slideshow__slide",
        currentSlide: ".is-selected",
        wrapper: ".slideshow-wrapper",
        pauseButton: ".slideshow__pause",
    };

    static productSelectors = {
        thumb: ".product__thumb-item:not(.hide)",
        links: ".product__thumb-item:not(.hide) a",
        arrow: ".product__thumb-arrow",
    };

    static defaults = {
        adaptiveHeight: false,
        autoPlay: false,
        avoidReflow: false,
        childNav: null,
        childNavScroller: null,
        childVertical: false,
        dragThreshold: 7,
        fade: false,
        friction: 0.8,
        initialIndex: 0,
        pageDots: false,
        pauseAutoPlayOnHover: false,
        prevNextButtons: false,
        rightToLeft: theme.config.rtl,
        selectedAttraction: 0.14,
        setGallerySize: true,
        wrapAround: true,
    };

    constructor(el, args) {
        this.el = el;
        this.args = Object.assign({}, Slideshow.defaults, args);

        this.args.on = {
            ready: this.init.bind(this),
            change: this.slideChange.bind(this),
            settle: this.afterChange.bind(this),
        };

        if (this.args.childNav) {
            this.childNavEls = this.args.childNav.querySelectorAll(Slideshow.productSelectors.thumb);
            this.childNavLinks = this.args.childNav.querySelectorAll(Slideshow.productSelectors.links);
            this.arrows = this.args.childNav.querySelectorAll(Slideshow.productSelectors.arrow);
            if (this.childNavLinks.length) {
                this.initChildNav();
            }
        }

        if (this.args.avoidReflow) {
            this.avoidReflow(el);
        }

        this.slideshow = new Flickity(el, this.args);

        if (el.dataset.zoom && el.dataset.zoom === "true") {
            this.slideshow.on("dragStart", () => {
                this.slideshow.slider.style.pointerEvents = "none";
                if (this.slideshow.options.fade) {
                    this.slideshow.slider.querySelector(".is-selected").style.pointerEvents = "none";
                }
            });
            this.slideshow.on("dragEnd", () => {
                this.slideshow.slider.style.pointerEvents = "auto";
                if (this.slideshow.options.fade) {
                    this.slideshow.slider.querySelector(".is-selected").style.pointerEvents = "auto";
                }
            });
        }

        if (this.args.autoPlay) {
            const wrapper = el.closest(Slideshow.selectors.wrapper);
            this.pauseBtn = wrapper.querySelector(Slideshow.selectors.pauseButton);
            if (this.pauseBtn) {
                this.pauseBtn.addEventListener("click", this._togglePause.bind(this));
            }
        }

        window.on(
            "resize",
            theme.utils.debounce(
                300,
                function () {
                    this.resize();
                }.bind(this)
            )
        );
    }

    avoidReflow(el) {
        if (!el.id) return;
        let firstChild = el.firstChild;
        while (firstChild != null && firstChild.nodeType === 3) {
            firstChild = firstChild.nextSibling;
        }
        const style = document.createElement("style");
        style.innerHTML = `#${el.id} .flickity-viewport{height:${firstChild.offsetHeight}px}`;
        document.head.appendChild(style);
    }

    init() {
        this.currentSlide = this.el.querySelector(Slideshow.selectors.currentSlide);
        if (this.args.callbacks && typeof this.args.callbacks.onInit === "function") {
            this.args.callbacks.onInit(this.currentSlide);
        }
        if (window.AOS) {
            AOS.refresh();
        }
    }

    slideChange(index) {
        if (this.args.fade && this.currentSlide) {
            this.currentSlide.classList.add(Slideshow.classes.animateOut);
            this.currentSlide.addEventListener(
                "transitionend",
                function () {
                    this.currentSlide.classList.remove(Slideshow.classes.animateOut);
                }.bind(this)
            );
        }

        if (this.args.childNav) {
            this.childNavGoTo(index);
        }

        if (this.args.callbacks && typeof this.args.callbacks.onChange === "function") {
            this.args.callbacks.onChange(index);
        }

        if (this.arrows && this.arrows.length) {
            this.arrows[0].classList.toggle("hide", index === 0);
            this.arrows[1].classList.toggle("hide", index === this.childNavLinks.length - 1);
        }
    }

    afterChange(index) {
        if (this.args.fade) {
            this.el.querySelectorAll(Slideshow.selectors.allSlides).forEach((slide) => {
                slide.classList.remove(Slideshow.classes.animateOut);
            });
        }

        this.currentSlide = this.el.querySelector(Slideshow.selectors.currentSlide);

        if (this.args.childNav) {
            this.childNavGoTo(this.slideshow.selectedIndex);
        }
    }

    destroy() {
        if (this.args.childNav && this.childNavLinks.length) {
            this.childNavLinks.forEach((a) => {
                a.classList.remove(Slideshow.classes.isActive);
            });
        }

        this.slideshow.destroy();
    }

    reposition() {
        this.slideshow.reposition();
    }

    _togglePause() {
        if (this.pauseBtn.classList.contains(Slideshow.classes.isPaused)) {
            this.pauseBtn.classList.remove(Slideshow.classes.isPaused);
            this.slideshow.playPlayer();
        } else {
            this.pauseBtn.classList.add(Slideshow.classes.isPaused);
            this.slideshow.pausePlayer();
        }
    }

    resize() {
        this.slideshow.resize();
    }

    play() {
        this.slideshow.playPlayer();
    }

    pause() {
        this.slideshow.pausePlayer();
    }

    goToSlide(i) {
        this.slideshow.select(i);
    }

    setDraggable(enable) {
        this.slideshow.options.draggable = enable;
        this.slideshow.updateDraggable();
    }

    initChildNav() {
        this.childNavLinks[this.args.initialIndex].classList.add("is-active");

        this.childNavLinks.forEach((link, i) => {
            link.setAttribute("data-index", i);

            link.addEventListener(
                "click",
                function (evt) {
                    evt.preventDefault();
                    this.goToSlide(this.getChildIndex(evt.currentTarget));
                }.bind(this)
            );
            link.addEventListener(
                "focus",
                function (evt) {
                    this.goToSlide(this.getChildIndex(evt.currentTarget));
                }.bind(this)
            );
            link.addEventListener(
                "keydown",
                function (evt) {
                    if (evt.keyCode === 13) {
                        this.goToSlide(this.getChildIndex(evt.currentTarget));
                    }
                }.bind(this)
            );
        });

        if (this.arrows.length) {
            this.arrows.forEach((arrow) => {
                arrow.addEventListener("click", this.arrowClick.bind(this));
            });
        }
    }

    getChildIndex(target) {
        return parseInt(target.dataset.index);
    }

    childNavGoTo(index) {
        this.childNavLinks.forEach((a) => {
            a.blur();
            a.classList.remove(Slideshow.classes.isActive);
        });

        const el = this.childNavLinks[index];
        el.classList.add(Slideshow.classes.isActive);

        if (!this.args.childNavScroller) {
            return;
        }

        if (this.args.childVertical) {
            const elTop = el.offsetTop;
            this.args.childNavScroller.scrollTop = elTop - 100;
        } else {
            const elLeft = el.offsetLeft;
            this.args.childNavScroller.scrollLeft = elLeft - 100;
        }
    }

    arrowClick(evt) {
        if (evt.currentTarget.classList.contains("product__thumb-arrow--prev")) {
            this.slideshow.previous();
        } else {
            this.slideshow.next();
        }
    }
}

theme.Slideshow = Slideshow;


document.addEventListener('DOMContentLoaded', function() {
    theme.sections = new theme.Sections();
    theme.sections.register("testimonials", theme.Testimonials);
    document.dispatchEvent(new CustomEvent("page:loaded"));
});
